var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "blob2",
    xmlnsXlink: "blob2",
    viewBox: "6531 1442 404 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ablob2{clip-path:url(#bb);}.bblob2{fill:#3db44c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6531,
    y: 1442,
    width: 404,
    height: 258
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa",
    className: "ablob2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bblob2",
    d: "M11077.119,1062.711s-36.2-15.311-59.1,25.757-149.676,23.039-103.027,78.273-101.17,56.237-21.037,114.476,18.126,39.065,74.362,0,180.745,56.438,198.776,21.094,135.971-95.5,100.771-135.57-95.047-72.278-100.771-71.276S11077.119,1062.711,11077.119,1062.711Z",
    transform: "translate(17805.074 2760.389) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob2.4dec84c29242efd2cdbf445b330ff188.svg";
export { ForwardRef as ReactComponent };